var React = require('react');

function WarningIcon (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.warning-icon-svg-1{fill:#FFFFFF;}\n\t.warning-icon-svg-2{fill:#F12938;}\n"),React.createElement("rect",{"x":"7.6","y":"4","className":"warning-icon-svg-1","width":"6.9","height":"13.3","key":1}),React.createElement("path",{"className":"warning-icon-svg-2","d":"M11,0C6.5,0-1.7,16.5,0.3,18.6s19.8,1.8,21.5,0C23.5,16.8,15.6,0,11,0z M12,16h-2v-2h2V16z M12,13h-2V5h2V13z","key":2})]);
}

WarningIcon.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 22 20","style":{"enableBackground":"new 0 0 22 20"},"xmlSpace":"preserve"};

module.exports = WarningIcon;

WarningIcon.default = WarningIcon;
